/* Goodnight — mobile drawer toggle.
   Listens for clicks on any element with [data-gn-drawer-toggle] attribute
   pointing to the drawer's id, plus the drawer overlay itself + .gn-drawer__close.
   Locks body scroll while open. Closes on Escape. */
(function () {
  'use strict';

  function findDrawer(target) {
    const toggle = target.closest('[data-gn-drawer-toggle]');
    if (toggle) return document.getElementById(toggle.getAttribute('data-gn-drawer-toggle'));
    const closeBtn = target.closest('.gn-drawer__close');
    if (closeBtn) return closeBtn.closest('.gn-drawer');
    const overlay = target.classList && target.classList.contains('gn-drawer') ? target : null;
    return overlay;
  }

  function setOpen(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('gn-drawer-open', open);
    const toggle = document.querySelector(`[data-gn-drawer-toggle="${drawer.id}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', function (e) {
    const drawer = findDrawer(e.target);
    if (!drawer) return;
    e.preventDefault();
    const isOpen = drawer.classList.contains('is-open');
    setOpen(drawer, !isOpen);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.gn-drawer.is-open').forEach(function (d) {
      setOpen(d, false);
    });
  });
})();
